/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface SlackChannel
 */
export interface SlackChannel {
    /**
     * 
     * @type {string}
     * @memberof SlackChannel
     */
    channelId: string;
    /**
     * 
     * @type {string}
     * @memberof SlackChannel
     */
    channelName: string;
    /**
     * 
     * @type {boolean}
     * @memberof SlackChannel
     */
    isPrivate: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SlackChannel
     */
    isMember: boolean;
}

export function SlackChannelFromJSON(json: any): SlackChannel {
    return {
        'channelId': json['channelId'],
        'channelName': json['channelName'],
        'isPrivate': json['isPrivate'],
        'isMember': json['isMember'],
    };
}

export function SlackChannelToJSON(value?: SlackChannel): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'channelId': value.channelId,
        'channelName': value.channelName,
        'isPrivate': value.isPrivate,
        'isMember': value.isMember,
    };
}


